export default [
  {
    path: '/myTask/writeReport',
    name: 'myTask_writeReport',
    meta: {
      checkLogin: true,
      keepAlive: false,
      isFooter: false,
      bgAudit: true,
      title: '填写报告',
      pageId: 'writeReport',
      pageName: '填写报告',
      parentId: 'myTask',
      parentName: '我的任务',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/myTask/writeReport'], resolve),
  },
  {
    path: '/myTask/viewReport',
    name: 'myTask_viewReport',
    meta: {
      checkLogin: true,
      keepAlive: false,
      isFooter: false,
      bgAudit: true,
      title: '预览报告',
      pageId: 'viewReport',
      pageName: '预览报告',
      parentId: 'myTask',
      parentName: '我的任务',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/myTask/viewReport'], resolve),
  },
];
